// Index file for the directory. Don't add anything else here.
import CarouselContentCreation from './CarouselContentCreation';
export default CarouselContentCreation;
